import {
  Box,
  TableCell,
  TableRow,
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useEffect, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PageTitle from "../../../../../components/pageTitle/PageTitle";
import TableDesign from "../../../../../components/common/table/TableDesign";
import { contracts, tableHeadings } from "./contractsUtils";
import StorageContract from "./storageContract";
import MoveOutStorageModal from "./MoveOutStorageModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getContractListAction,
  getSingleContractAction,
  setCreateContractResponseAction,
  deleteContractAction,
  setDeleteContractResponseAction,
  setEmailContractResponseAction,
  setPrintContractResponseAction,
  invoiceGenerateForMoveToJob,
  setInvoiceGeneratedForMoveToJobResponse,
  checkServiceForContractAction,
  setCheckServiceForContractResponse,
  moveToJobFinalAction,
  setMoveToJobFinalResponse,
  sendContractSignLinkAction,
} from "../../../../../store/reducers/contractStorageSlice";
import dayjs from "dayjs";
import ManageInvoiceGenerate from "../invoice/ManageInvoiceGenerate";
import { setNotificationAction } from "../../../../../store/reducers/mmymSlice";
import ManageInventoryList from "../inventory/ManageInventoryList";
import DeleteAlert from "../../../../../components/common/DeleteAlert";
import {
  emailContractAction,
  printContractAction,
} from "../../../../../store/reducers/contractStorageSlice";
import { getAllTCDocumentListAction } from "../../../../../store/reducers/documentSlice";
import { getAllEmailTemplatesAction } from "../../../../../store/reducers/emailTemplateSlice";
import AlertPopup from "../../../../../components/common/alertPopup/AlertPopup";

type ContractConfirmationAction = "delete" | "email" | "print";

const isClosedContract = (contract: any) =>
  String(contract?.status ?? "").toLowerCase() === "closed";

const ContractList = ({ generateId }: any) => {
  const dispatch = useDispatch();
  const [showContract, setShowContract] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  // Action menu state
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [actionRow, setActionRow] = useState<any>(null);
  const [confirmationRow, setConfirmationRow] = useState<any>(null);
  const [confirmationAction, setConfirmationAction] =
    useState<ContractConfirmationAction | null>(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [moveOutOpen, setMoveOutOpen] = useState(false);
  const [moveOutRow, setMoveOutRow] = useState<any>(null);
  const [inventoryReadOnly, setInventoryReadOnly] = useState(false);
  const [alertModel, setAlertModel] = useState(false);
  const { storageDetails } = useSelector((state: any) => state.storage);
  const {
    contractList,
    contractPagination,
    isCreateContractResponse,
    isDeletedContractResponse,
    isEmailContractResponse,
    isPrintContractResponse,
    isFinalInvoiceGenerateToMoveJob,
    isMoveToFinalResponse,
    checkSerivceForContract,
  } = useSelector((state: any) => state.contractStorage);
  const { userProfile } = useSelector((state: any) => state?.user);
  const {allEmailTemplates} = useSelector((state:any)=> state?.emailTemplates);
  const contractTemplates = useSelector((state: any) =>
    Array.isArray(state.document?.contractODTTemplate)
      ? state.document.contractODTTemplate
      : [],
  );
  const [invoiceModel, setInvoiceModel] = useState(false);
  const [inventoryModel, setInventoryModel] = useState(false);
  const [inventoryContractId, setInventoryContractId] = useState<
    string | number | null
  >(null);
  const [selectedInvoiceRow, setSelectedInvoiceRow] = useState<any[]>([]);
  const [filterData, setFilterData] = useState({
    leadId: null,
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    if (filterData?.page && filterData?.limit && generateId) {
      dispatch(
        getContractListAction({
          ...filterData,
          leadId: generateId,
        }),
      );
    }
  }, [dispatch, filterData, generateId]);

  useEffect(() => {
    if (!isFinalInvoiceGenerateToMoveJob) {
      return;
    }

    const leadId = moveOutRow?.storageLeadId ?? generateId ?? null;
    if (leadId) {
      dispatch(
        getContractListAction({
          ...filterData,
          leadId,
        }),
      );
    }
    handleCloseMoveOut();
    dispatch(setInvoiceGeneratedForMoveToJobResponse(false));
  }, [dispatch, filterData, isFinalInvoiceGenerateToMoveJob, moveOutRow]);

  useEffect(() => {
    if (!isMoveToFinalResponse) {
      return;
    }

    const leadId = moveOutRow?.storageLeadId ?? generateId;
    if (leadId) {
      dispatch(
        getContractListAction({
          ...filterData,
          leadId,
        }),
      );
    }
    handleCloseMoveOut();
    dispatch(setMoveToJobFinalResponse(false));
  }, [dispatch, filterData, generateId, isMoveToFinalResponse, moveOutRow]);

  useEffect(() => {
    if (isCreateContractResponse) {
      dispatch(
        getContractListAction({
          ...filterData,
          leadId: generateId,
        }),
      );
      handleClose();
      dispatch(setCreateContractResponseAction(false));
    }
  }, [isCreateContractResponse]);

  useEffect(() => {
    if (isDeletedContractResponse) {
      dispatch(
        getContractListAction({
          ...filterData,
          leadId: generateId,
        }),
      );
      setSelectedInvoiceRow([]);
      setConfirmationOpen(false);
      setConfirmationRow(null);
      setConfirmationAction(null);
      dispatch(setDeleteContractResponseAction(false));
    }
  }, [dispatch, filterData, generateId, isDeletedContractResponse]);

  useEffect(() => {
    if (isEmailContractResponse) {
      setConfirmationOpen(false);
      setConfirmationRow(null);
      setConfirmationAction(null);
      dispatch(setEmailContractResponseAction(false));
    }
  }, [dispatch, isEmailContractResponse]);

  useEffect(() => {
    if (isPrintContractResponse) {
      setConfirmationOpen(false);
      setConfirmationRow(null);
      setConfirmationAction(null);
      dispatch(setPrintContractResponseAction(false));
    }
  }, [dispatch, isPrintContractResponse]);

  const handleClose = () => {
    setShowContract(false);
    setSelectedRow(null);
    setSelectedInvoiceRow([]);
  };

  /** * Checkbox selection */ const handleCheckboxChange = (row: any) => {
    setSelectedInvoiceRow((prev) => {
      const alreadySelected = prev.some((item) => item?.id === row?.id);
      if (alreadySelected) {
        return prev.filter((item) => item?.id !== row?.id);
      }
      return [...prev, row];
    });
  };
  /** * Select / Unselect all */

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedInvoiceRow(
        (contractList || []).filter((row: any) => !isClosedContract(row)),
      );
    } else {
      setSelectedInvoiceRow([]);
    }
  };
  /** * Check whether row is selected */
  const isRowSelected = (row: any) => {
    return selectedInvoiceRow.some((item) => item?.id === row?.id);
  };
  const hasInvoiceableSelection = selectedInvoiceRow.some(
    (row) => !isClosedContract(row),
  );
  /**
   * Open 3-dot action menu
   */
  const handleActionClick = (
    event: React.MouseEvent<HTMLElement>,
    row: any,
  ) => {
    event.stopPropagation();

    setAnchorEl(event.currentTarget);
    setActionRow(row);
  };

  /**
   * Close 3-dot action menu
   */
  const handleActionMenuClose = () => {
    setAnchorEl(null);
    setActionRow(null);
  };

  /**
   * Edit Contract
   */
  const handleEditClick = () => {
    if (!actionRow) return;

    setShowContract(true);
    setSelectedRow(actionRow);

    handleActionMenuClose();
  };

  /**
   * Generate Invoice
   */
  const handleGenerateInvoice = () => {
    if (!actionRow || isClosedContract(actionRow)) return;
    setInvoiceModel(true);
    setSelectedInvoiceRow([actionRow]);

    handleActionMenuClose();
  };

  /** * Generate Invoice Up To for selected contracts */
  const handleInvoiceUpTo = () => {
    const invoiceableRows = selectedInvoiceRow.filter(
      (row) => !isClosedContract(row),
    );
    if (invoiceableRows.length === 0) return;
    setSelectedInvoiceRow(invoiceableRows);
    setInvoiceModel(true);
  };

  const handleOpenInventory = () => {
    setInventoryContractId(
      actionRow?.contractId ?? actionRow?.id ?? actionRow?._id ?? null,
    );
    setInventoryReadOnly(isClosedContract(actionRow));
    setInventoryModel(true);
    handleActionMenuClose();
  };

  const handleMoveOutClick = () => {
    if (!actionRow || isClosedContract(actionRow)) return;

    setMoveOutRow(actionRow);
    setMoveOutOpen(true);
    handleActionMenuClose();
  };

  const handleCloseMoveOut = () => {
    setMoveOutOpen(false);
    setMoveOutRow(null);
    dispatch(setCheckServiceForContractResponse(null));
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  const handleGenerateFinalInvoice = () => {
    const contractId =
      moveOutRow?.contractId ?? moveOutRow?.id ?? moveOutRow?._id;
    const leadId = moveOutRow?.storageLeadId ?? null;
    if (!contractId || !leadId) return;

    dispatch(invoiceGenerateForMoveToJob({ contractId, leadId }));
  };

  const handleCheckServiceForMoveToJob = () => {
    const contractId =
      moveOutRow?.contractId ?? moveOutRow?.id ?? moveOutRow?._id;
    const leadId = moveOutRow?.removalLeadId;
    if (!contractId) return;
    if (!leadId) {
      handleMoveToJobFinal(false);
      return;
    }

    dispatch(setCheckServiceForContractResponse(null));
    dispatch(checkServiceForContractAction({ contractId, leadId }));
  };

  const handleMoveToJobFinal = (isNewLead: boolean) => {
    const contractId =
      moveOutRow?.contractId ?? moveOutRow?.id ?? moveOutRow?._id;
    const removalLeadId = moveOutRow?.removalLeadId;
    if (!contractId || (isNewLead && !removalLeadId)) {
      dispatch(
        setNotificationAction({
          message: ["Contract and removal lead are required to move to final."],
          severity: "error",
        }),
      );
      return;
    }

    dispatch(setMoveToJobFinalResponse(false));
    dispatch(
      moveToJobFinalAction({
        contractId,
        is_new_lead: isNewLead,
        removal_lead_id: removalLeadId ? String(removalLeadId) : null,
      }),
    );
  };

  const handleDeleteClick = () => {
    if (!actionRow) return;

    setConfirmationRow(actionRow);
    setConfirmationAction("delete");
    setConfirmationOpen(true);
    handleActionMenuClose();
  };

  const handleEmailClick = () => {
    if (!actionRow) return;

    setSelectedTemplateId("");
    setConfirmationRow(actionRow);
    setConfirmationAction("email");
    setConfirmationOpen(true);
    dispatch(getAllEmailTemplatesAction({ lead_stage: "STORAGE_CONTRACT" }));
    handleActionMenuClose();
  };

  const handlePrintClick = () => {
    if (!actionRow) return;

    setSelectedTemplateId("");
    setConfirmationRow(actionRow);
    setConfirmationAction("print");
    setConfirmationOpen(true);
    dispatch(getAllTCDocumentListAction());
    handleActionMenuClose();
  };

  const closeContractActionConfirmation = () => {
    setConfirmationOpen(false);
    setConfirmationRow(null);
    setConfirmationAction(null);
    setSelectedTemplateId("");
  };

  const handleConfirmationVisibilityChange = (open: boolean) => {
    setConfirmationOpen(open);
    if (!open) {
      setConfirmationRow(null);
      setConfirmationAction(null);
      setSelectedTemplateId("");
    }
  };

  const handleConfirmContractAction = () => {
    const contractId =
      confirmationRow?.contractId ??
      confirmationRow?.id ??
      confirmationRow?._id;
    if (!contractId) return;

    if (confirmationAction === "delete") {
      dispatch(deleteContractAction({ contractId }));
    } else if (confirmationAction === "email") {
      if (!selectedTemplateId) return;
      dispatch(
        emailContractAction({ contractId, templateId: selectedTemplateId }),
      );
    } else if (confirmationAction === "print") {
      if (!selectedTemplateId) return;
      dispatch(
        printContractAction({ contractId, templateId: selectedTemplateId }),
      );
    }
  };

  useEffect(() => {
    if (selectedRow) {
      dispatch(getSingleContractAction(selectedRow));
    }
  }, [dispatch, selectedRow]);

  useEffect(() => {
    if (!showContract) {
      setSelectedRow(null);
    }
  }, [showContract]);

  const handleOpenSignLink =()=>{
    setAlertModel(true);
     dispatch(setNotificationAction({ message: [], severity: "error" }));
  }

  const handleSendSignLink =()=>{
    
    dispatch(sendContractSignLinkAction({contractId:actionRow?.id}));
  }

  console.log("moveOutRow 431", moveOutRow);
  return (
    <>
      <PageTitle
        title="List of Contracts"
        button="Manage Contract"
        onClick={() => setShowContract(true)}
        button1={hasInvoiceableSelection ? "Invoice Up To" : ""}
        onClick1={handleInvoiceUpTo}
      />
      <StorageContract
        show={showContract}
        setShow={setShowContract}
        isReadOnly={isClosedContract(selectedRow)}
      />

      <Box
        sx={{
          bgcolor: "#fff",
          height: {
            xs: "auto",
            sm: contractList?.length > 1 ? "auto" : "20vh",
          },
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          padding: "0px",
          overflow: "hidden",
        }}
      >
        <TableDesign
          tableHeadings={tableHeadings}
          tableHeadColor={"#02906f"}
          cellColor={"#fff"}
          pagination={contractList?.length > 0 ? contractPagination : null}
          isLoader={false}
          stickyHeader={true}
          filterOption={() => {}}
          setFilterOption={() => {}}
          extraCSS={{
            height: "calc(100%)",
          }}
        >
          {contractList?.length > 0 ? (
            contractList?.map((val: any, idx: number) => (
              <TableRow
                key={val?.id}
                sx={{
                  cursor: "pointer",
                  marginTop: "10px",
                  padding: "4px !important",
                  borderRadius: "20px !important",
                  height: "20px !important",
                  backgroundColor: isClosedContract(val)
                    ? "#fff0f0"
                    : undefined,
                  "& > td": {
                    backgroundColor: isClosedContract(val)
                      ? "#fff0f0"
                      : undefined,
                  },
                  "&:hover": {
                    backgroundColor: isClosedContract(val)
                      ? "#ffe2e2"
                      : "#f0f0f0",
                    "& > td": {
                      backgroundColor: isClosedContract(val)
                        ? "#ffe2e2"
                        : "#f0f0f0",
                    },
                    outline: isClosedContract(val)
                      ? "2px solid #ffe2e2"
                      : "2px solid #f0f0f0",
                    borderRadius: "0px !important",
                    outlineOffset: "-2px !important",
                  },
                }}
              >
                {/* Checkbox */}{" "}
                <TableCell padding="checkbox">
                  {" "}
                  <Checkbox
                    checked={isRowSelected(val)}
                    onChange={() => handleCheckboxChange(val)}
                    onClick={(event) => event.stopPropagation()}
                    disabled={isClosedContract(val)}
                  />{" "}
                </TableCell>
                <TableCell>{val?.title}</TableCell>
                <TableCell>{val?.contractType}</TableCell>
                <TableCell>
                  {val?.startDate
                    ? dayjs(val?.startDate).format(
                        userProfile?.dateFormat
                          ? userProfile?.dateFormat
                          : "DD/MM/YYYY",
                      )
                    : ""}
                </TableCell>
                <TableCell>
                  {val?.endDate
                    ? dayjs(val?.endDate).format(
                        userProfile?.dateFormat
                          ? userProfile?.dateFormat
                          : "DD/MM/YYYY",
                      )
                    : ""}
                </TableCell>
                {/* Action */}
                <TableCell align="center">
                  <IconButton
                    size="small"
                    onClick={(event) => handleActionClick(event, val)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={tableHeadings?.length} align="center">
                {`No Data Found!`}
              </TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Box>
      {/* Contract Actions Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleActionMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleEditClick}>Edit</MenuItem>
        {!isClosedContract(actionRow) && (
          <MenuItem onClick={handleGenerateInvoice}>Generate Invoice</MenuItem>
        )}
        <MenuItem onClick={handleOpenInventory}>Inventory View</MenuItem>
        <MenuItem onClick={handleOpenSignLink}>Send Signing Link</MenuItem>
        {!isClosedContract(actionRow) && (
          <MenuItem onClick={handleMoveOutClick}>Move out of storage</MenuItem>
        )}
        <MenuItem onClick={handleEmailClick}>Email</MenuItem>
        <MenuItem onClick={handlePrintClick}>Print</MenuItem>
        {!isClosedContract(actionRow) && (
          <MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
        )}
      </Menu>
      {alertModel &&
      <>
       <AlertPopup
            open={alertModel}
            onHide={()=>{
              setAlertModel(false);
               dispatch(setNotificationAction({ message: [], severity: "error" }));
            }}
            title={"Alert"}
            content={"Are you sure you want to send link ?"}
            submitHandler={handleSendSignLink}
          />
      </>}
      {moveOutOpen && (
        <MoveOutStorageModal
          open={moveOutOpen}
          contractTitle={moveOutRow?.title || "this contract"}
          removalLeadId={moveOutRow?.removalLeadId}
          rowSelected={moveOutRow}
          serviceCheckResult={checkSerivceForContract}
          onClose={handleCloseMoveOut}
          onGenerateFinalInvoice={handleGenerateFinalInvoice}
          onCheckService={handleCheckServiceForMoveToJob}
          onConfirmationSaved={handleMoveToJobFinal}
        />
      )}
      {confirmationOpen && (
        <DeleteAlert
          open={confirmationOpen}
          alertModalShow={confirmationOpen}
          setAlertModelShow={handleConfirmationVisibilityChange}
          onHide={closeContractActionConfirmation}
          title={`${confirmationAction === "delete" ? "Delete" : confirmationAction === "email" ? "Email" : "Print"} Contract`}
          message={`Are you sure you want to ${confirmationAction} this ${confirmationRow?.title || `Contract`}?`}
          onConfirm={handleConfirmContractAction}
          confirmDisabled={
            (confirmationAction === "email" ||
              confirmationAction === "print") &&
            !selectedTemplateId
          }
          children={
            confirmationAction === "email" || confirmationAction === "print" ? (
              <FormControl fullWidth size="small" sx={{ my: 2 }}>
                <InputLabel id="contract-template-label">
                  Select Contract Template
                </InputLabel>
                 <Select
        labelId="contract-template-label"
        value={selectedTemplateId}
        label={
          confirmationAction === "email"
            ? "Select Email Template"
            : "Select Contract Template"
        }
        onChange={(event) =>
          setSelectedTemplateId(event.target.value)
        }
      >
        {confirmationAction === "email" ? (
          Array.isArray(allEmailTemplates) &&
          allEmailTemplates.length > 0 ? (
            allEmailTemplates.map((template: any) => (
              <MenuItem
                key={template?.template_id}
                value={String(template?.template_id ?? "")}
              >
                {template?.template_name || "Email Template"}
              </MenuItem>
            ))
          ) : (
            <MenuItem value="" disabled>
              No email templates available
            </MenuItem>
          )
        ) : contractTemplates.length > 0 ? (
          contractTemplates.map((template: any) => (
            <MenuItem
              key={template?.doc_id}
              value={String(template?.doc_id ?? "")}
            >
              {template?.name?.trim() || "Storage Contract Template"}
            </MenuItem>
          ))
        ) : (
          <MenuItem value="" disabled>
            No storage templates available
          </MenuItem>
        )}
      </Select>
              </FormControl>
            ) : null
          }
        />
      )}
      {invoiceModel && (
        <ManageInvoiceGenerate
          open={invoiceModel}
          title={"Generate Invoice"}
          selectedRow={selectedInvoiceRow}
          // onCreate={() => {}}
          onHide={() => {
            setInvoiceModel(false);
            setSelectedInvoiceRow([]);
            dispatch(setNotificationAction({ message: [], severity: "error" }));
          }}
        />
      )}

      {inventoryModel && (
        <ManageInventoryList
          open={inventoryModel}
          title="Inventory List"
          contractId={inventoryContractId}
          sourceRemovalId={storageDetails?.sourceRemovalLeadId ?? null}
          readOnly={inventoryReadOnly}
          onHide={() => {
            setInventoryModel(false);
            setInventoryContractId(null);
            setInventoryReadOnly(false);
            dispatch(setNotificationAction({ message: [], severity: "error" }));
          }}
        />
      )}
    </>
  );
};

export default ContractList;
